import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import useSeo from '@/hooks/useSeo';
import { faqs } from '@/mocks/faqs';
import HeroSection from '@/pages/home/components/HeroSection';
import HotSection from '@/pages/home/components/HotSection';
import CategorySection from '@/pages/home/components/CategorySection';
import TrackSection from '@/pages/home/components/TrackSection';
import GuideSection from '@/pages/home/components/GuideSection';
import FaqSection from '@/pages/home/components/FaqSection';
import AboutSection from '@/pages/home/components/AboutSection';

export default function Home() {
  useSeo({
    title: '西瓜瓜田 | 娱乐吃瓜线索追踪站，主角小号真实身份不迷路',
    description:
      '西瓜瓜田整理娱乐热点线索：顺着西瓜黑料主角顺藤摸瓜，盯住西瓜黑料小号，再结合女主、男主与当事人说法，帮你分清这场瓜谁在演、谁在回应。',
    keywords: '西瓜黑料, 西瓜黑料主角, 西瓜黑料小号, 西瓜黑料女主, 娱乐吃瓜, 线索追踪, 真伪鉴定',
    path: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '西瓜瓜田',
        url: 'https://xiguaguatian.example.com/',
        description: '娱乐吃瓜线索追踪站，整理主角、小号与真实身份的公开讨论线索。',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://xiguaguatian.example.com/category/event-track?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '西瓜瓜田',
        url: 'https://xiguaguatian.example.com/',
        email: 'gua@xiguaguatian.example.com',
        description: '专注娱乐线索整理与真伪分析的内容编辑部。',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
    ],
  });

  return (
    <>
      <SiteHeader />
      <main>
        <HeroSection />
        <HotSection />
        <CategorySection />
        <TrackSection />
        <GuideSection />
        <FaqSection />
        <AboutSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}